// Home services Bricks quotes on www.brxs.ca/services (one page, one form with
// a trade picker). Every one is a quote request: no prices here, nothing is
// booked until the client approves the written quote. The keys match the
// www trade slugs, so /services#quote-<slug> opens the form on that trade.
import { PROPERTY_KINDS } from "./clientTypes";
import TRADE_SPECS from "./tradeSpecs.json";

export const SERVICES_URL = "https://www.brxs.ca/services";

export const HOME_SERVICES = {
  staging: { name: "Home staging", line: "Vacant or lived-in, timed before the photo visit." },
  cleaning: { name: "Cleaning and turnovers", line: "Pre-listing, move-in, move-out and post-construction." },
  inspections: { name: "Inspections", line: "Home and building condition, Ontario only." },
  measurement: { name: "Measurement and floor area", line: "Measured floor area and plans. Legal surveys go to an Ontario Land Surveyor." },
  repairs: { name: "Handyman and repairs", line: "Small repairs and deficiency lists. No electrical, plumbing or gas." },
};

// www slug -> vendor type in the shared trade registry (tradeSpecs.json, a copy of
// Dispatch trade_specs.json). A trade with enabled=false is paused: hidden here.
const SLUG_TRADE = { staging: "stager", cleaning: "cleaner", inspections: "inspector", measurement: "measurer", repairs: "handyman" };
export const isServiceEnabled = (slug) => TRADE_SPECS.trades[SLUG_TRADE[slug]]?.enabled !== false;

// Which trades each client type sees, most useful first. Agents list homes,
// so they get staging and cleaning; property accounts get all five.
const BY_KIND = {
  property_manager: ["cleaning", "repairs", "inspections", "measurement", "staging"],
  builder: ["cleaning", "inspections", "measurement", "repairs", "staging"],
  reit_leasing: ["inspections", "measurement", "cleaning", "repairs", "staging"],
  commercial: ["measurement", "inspections", "cleaning", "repairs", "staging"],
  investor: ["inspections", "repairs", "cleaning", "measurement", "staging"],
};
export const AGENT_TRADES = ["staging", "cleaning"];

export function homeServicesFor(kind) {
  if (kind === "platform" || kind === "vendor" || !kind) return [];
  const keys = PROPERTY_KINDS.includes(kind) ? BY_KIND[kind] : AGENT_TRADES;
  return keys.filter(isServiceEnabled).map((slug) => ({ slug, ...HOME_SERVICES[slug], href: quoteHref(slug) }));
}

export const quoteHref = (slug) => `${SERVICES_URL}#quote-${slug}`;
